import { render, staticRenderFns } from "./TabsContainer.vue?vue&type=template&id=3a7510b6&scoped=true&"
import script from "./TabsContainer.vue?vue&type=script&lang=js&"
export * from "./TabsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TabsContainer.vue?vue&type=style&index=0&id=3a7510b6&scoped=true&lang=css&"
import style1 from "./TabsContainer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7510b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTab,VTabItem,VTabs,VTabsItems,VTooltip})
